const icons = [
  'Header',
  'add-contact',
  'add-note',
  'add-remove',
  'agent',
  'alert',
  'align-center',
  'align-left',
  'align-right',
  'align-justify',
  'annotate',
  'announcement',
  'arrow-left',
  'arrow-right',
  'article-analytics',
  'article-expand',
  'article-seo',
  'at-the-rate',
  'attachment-forward',
  'attachment',
  'browser',
  'bulb',
  'calendar-time',
  'calendar',
  'canned-forms',
  'canned-responses',
  'cell',
  'chat-offline',
  'chat-online',
  'check-big',
  'check',
  'checkbox',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
];

export default icons;
